import styled from 'styled-components';

import { Theme } from '../Theme';

export const FlexRow = styled.div`
	display: flex;
	flex-direction: ${(props) => (props.reverse ? 'row-reverse' : 'row')};
	font-size: 14px;
	font-family: Arial;
	justify-content: ${(props) => (props.align || 'flex-start')};
	@media only screen and (max-width: ${(props) => (props.responsive ? props.responsive : null)}) {
		flex-direction: column;
		padding: 0 8px;
		justify-content: center;
	}
`;
